import React from "react";
import { Hero } from "@/marketing/home/Hero";
import { FeatureStrip, Pillars } from "@/marketing/home/Intro";
import { Showcase } from "@/marketing/home/Showcase";
import { OfflineSpotlight } from "@/marketing/home/OfflineSpotlight";
import { PricingTeaser, CtaBanner } from "@/marketing/home/Pricing";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <FeatureStrip />
      <Pillars />
      <Showcase />
      <OfflineSpotlight />
      <PricingTeaser />
      <CtaBanner />
    </div>
  );
}
